import { Duration } from 'dayjs/plugin/duration';

import { SBaseDisplay, SDuration } from '@summit/core';

import { SummitFormattedText } from '@summit/models';
import { EboObject } from '../../base-classes/ebo-object';
import { EProcessType, EProcessTypeMapping } from '../../process/e-process-type.enum';
import { Division } from '../division';
import { DivisionPolicyRestriction } from './division-policy-restriction';
import { DivisionPolicyStep } from './division-policy-step';

export class DivisionPolicy extends EboObject implements SBaseDisplay {
  divisionId: string;
  division: Division;
  group: EProcessType;
  description: string;
  minimumWindowPrior: Duration;
  steps: DivisionPolicyStep[];
  restrictions: DivisionPolicyRestriction[];

  //hack for typing
  get minimumWindowPriorDays(): number {
    return this.minimumWindowPrior?.asDays();
  }
  set minimumWindowPriorDays(value: number) {
    this.minimumWindowPrior = SDuration.new(value * 24);
  }

  constructor(jsonData?: Partial<DivisionPolicy>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.division) this.division = new Division(jsonData.division);
      if (jsonData.minimumWindowPrior) this.minimumWindowPrior = SDuration.new(jsonData.minimumWindowPrior);
      if (jsonData.steps) this.steps = jsonData.steps.map((s) => new DivisionPolicyStep(s));
      if (jsonData.restrictions) this.restrictions = jsonData.restrictions.map((r) => new DivisionPolicyRestriction(r));
    }
  }

  toShortString(): string {
    if (this.minimumWindowPrior)
      return `${EProcessTypeMapping[this.group]}: Lead Time of ${this.minimumWindowPrior.humanize()}`;
    return `${EProcessTypeMapping[this.group]}`;
  }

  get stepsSummary(): SummitFormattedText {
    const summary = new SummitFormattedText();
    if (this.steps && this.steps.length > 0) {
      this.steps.forEach((s) => summary.AddText(s.toSummary()));
    }
    return summary;
  }
  set stepsSummary(value: SummitFormattedText) {
    //NOP
  }

  get restrictionSummary(): SummitFormattedText {
    const summary = new SummitFormattedText();
    if (this.minimumWindowPrior) summary.AddKeyValues('Minimum Lead Time', this.minimumWindowPrior.humanize());
    if (this.restrictions && this.restrictions.length > 0) {
      this.restrictions.forEach((r) => summary.AddText(r.toSummary()));
    }
    return summary;
  }
  set restrictionSummary(value: SummitFormattedText) {
    //NOP
  }

  toSummary(): SummitFormattedText {
    const summary = new SummitFormattedText();
    summary.AddHtml(this.description);
    summary.AddLine('Restrictions', ['flex', 'flex-row', 'justify-center']);
    summary.AddText(this.restrictionSummary);
    summary.AddLine('Policy', ['flex', 'flex-row', 'justify-center']);
    summary.AddText(this.stepsSummary);
    return summary;
  }
}
